import type { CountryWithEmergencyContact, ListResponseCountry } from "@classes-service-types/index.ts";
import { type UseQueryOptions, useQuery } from "@tanstack/vue-query";
import type { Ref } from "vue";
import { computed } from "vue";
import countriesService from "@/services/countries.js";

interface Args<TData = CountryWithEmergencyContact[]> {
  limit: number;
  page: number;
  q: Ref<string>;
  useQueryOptions?: Partial<UseQueryOptions<CountryWithEmergencyContact[], Error, TData>>;
}

export const useGetCountriesData = <TData = CountryWithEmergencyContact[]>({
  limit,
  page,
  q,
  useQueryOptions,
}: Args<TData>) => {
  const fetchCountries = (): Promise<CountryWithEmergencyContact[]> =>
    countriesService
      .searchCountries({
        limit: limit,
        page: page,
        q: q.value ?? "",
      })
      .then((val: { data: ListResponseCountry }) => val?.data?.data);

  return useQuery<CountryWithEmergencyContact[], Error, TData>({
    queryKey: computed(() => ["fetchCountriesData", limit, page, q]),
    queryFn: fetchCountries,
    ...useQueryOptions,
  });
};
